import React, { useCallback, useEffect } from 'react';

/*
    This hook accepts a keycode identifying which key to watch for and an event
    to call if that keycode is pressed, and a ref to apply the event listener to.

    If no dependencies are specified then every re-render the event will be registered/unregistered.
    If you specify an empty array then it will only register once, but it will create a clojure around
    your props which will result in the event being called with old prop data.  If you have props that
    your callback function uses then you should specify them in the dependencies array so that the event
    only gets re-registered when they change.
*/

export const keyCodes = {
    enter: 13,
    escape: 27,
    upArrow: 38,
    downArrow: 40
};

export const useKeydownEvent = (eventKeycode, event, elementRef, dependencies) => {
    const handleKeydown = function(e) {
        if (eventKeycode === e.keyCode) {
            event(e);
        }
    };

    useEffect(()=> {
        elementRef?.current?.addEventListener('keydown', handleKeydown, false);
        return ()=> {
            elementRef?.current?.removeEventListener('keydown', handleKeydown, false);
        };
    }, dependencies);
};
